/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DatabaseCategoryFieldAnzeige
 */
export interface DatabaseCategoryFieldAnzeige {
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldAnzeige
     */
    list?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldAnzeige
     */
    grid?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseCategoryFieldAnzeige
     */
    gallery?: string;
}

/**
 * Check if a given object implements the DatabaseCategoryFieldAnzeige interface.
 */
export function instanceOfDatabaseCategoryFieldAnzeige(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabaseCategoryFieldAnzeigeFromJSON(json: any): DatabaseCategoryFieldAnzeige {
    return DatabaseCategoryFieldAnzeigeFromJSONTyped(json, false);
}

export function DatabaseCategoryFieldAnzeigeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabaseCategoryFieldAnzeige {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': !exists(json, 'list') ? undefined : json['list'],
        'grid': !exists(json, 'grid') ? undefined : json['grid'],
        'gallery': !exists(json, 'gallery') ? undefined : json['gallery'],
    };
}

export function DatabaseCategoryFieldAnzeigeToJSON(value?: DatabaseCategoryFieldAnzeige | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': value.list,
        'grid': value.grid,
        'gallery': value.gallery,
    };
}

